/**
 * Constantes de cidades e estados
 * Single Source of Truth para nomes, siglas e identificadores
 */

// Estados (siglas uppercase para exibição)
export const STATES = {
	SAO_PAULO: 'SP',
	PARANA: 'PR'
} as const;

// Estados (lowercase para APIs/filtros)
export const STATE_CODES = {
	SAO_PAULO: 'SP',
	PARANA: 'PR'
} as const;

// Cidades
export const CITIES = {
	SAO_PAULO: {
		id: 'sao-paulo',
		name: 'São Paulo',
		state: STATES.SAO_PAULO,
		stateCode: STATE_CODES.SAO_PAULO,
		macroregionName: 'Capital'
	},
	CURITIBA: {
		id: 'curitiba',
		name: 'Curitiba',
		state: STATES.PARANA,
		stateCode: STATE_CODES.PARANA,
		macroregionName: 'Curitiba'
	}
} as const;

// Macrorregiões
export const MACROREGIONS = {
	SAO_PAULO: 'São Paulo',
	CURITIBA: 'Curitiba',
	ALPHAVILLE: 'Alphaville',
	INTERIOR: 'Interior',
	LITORAL_NORTE: 'Litoral Norte',
	LITORAL_SUL: 'Litoral Sul'
} as const;

// Type helpers para inferência
export type StateCode = (typeof STATES)[keyof typeof STATES];
export type StateCodeLower = (typeof STATE_CODES)[keyof typeof STATE_CODES];
export type CityId = (typeof CITIES)[keyof typeof CITIES]['id'];
export type MacroregionName = (typeof MACROREGIONS)[keyof typeof MACROREGIONS];
